<ng-template #input>
	<div class="input-wrapper"
		 *transloco="let t;"
		 [class.input-required]="control.pristine && !control.disabled && isControlRequired && !control.touched">
		<button class="btn btn-outline-default btn-clear"
				*ngIf="control.value && control.value"
				(click)="clear()"
				type="button">
			{{ t('journal.common.clear') | uppercase }}
		</button>
		<ng-select
			*ngIf="!multiple && template !== 'inline'"
			[id]="id"
			class="form-control"
			[ngClass]="{invalid: control.touched && control.errors}"
			[formControl]="control"
			[placeholder]="'― ' + placeholder"
			[items]="options"
			(open)="selectOpen = true"
			(close)="selectOpen = false"
			#ngSelect>
			<ng-template ng-option-tmp let-item="item">
				<div class="option" title="{{item}}">
					<span class="option-content">{{item}}</span>
				</div>
			</ng-template>
		</ng-select>
		<ng-select
			*ngIf="multiple && template !== 'inline'"
			[id]="id"
			class="form-control"
			[ngClass]="{invalid: control.touched && control.errors}"
			[formControl]="control"
			[placeholder]="'― ' + placeholder"
			[multiple]="true"
			[compareWith]="compareWithIndex"
			[items]="innerOptions"
			[closeOnSelect]="false"
			(change)="checkSelectValue()"
			(open)="selectOpen = true"
			(close)="selectOpen = false"
			#ngSelect>
			<ng-template ng-label-tmp let-item="item" let-clear="clear">
				<button class="btn btn-sm btn-outline-primary" type="button"
						[ngbTooltip]="item.key"
						container="body">
					<span class="ng-value-icon left" (click)="clear(item);" aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
					<span class="ng-value-label">{{item.key}}</span>
				</button>
			</ng-template>
			<ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
				<div class="option" title="{{item.key}}">
					<span class="option-content">{{item.key}}</span>
					<input class="checkbox" id="item-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
					<span class="checkmark"></span>
				</div>
			</ng-template>
		</ng-select>

		<ng-select
			*ngIf="!multiple && template === 'inline'"
			[id]="id"
			class="form-control inline-control"
			[ngClass]="{invalid: control.touched && control.errors}"
			[formControl]="control"
			[placeholder]="'― ' + placeholder"
			[items]="options"
			[isOpen]="true"
			(open)="selectOpen = true"
			(close)="selectOpen = false">
			<ng-template ng-option-tmp let-item="item">
				<div class="option" title="{{item}}">
					<span class="option-content">{{item}}</span>
				</div>
			</ng-template>
			<ng-template *ngIf="control.touched && control.errors" ng-footer-tmp>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-template>
		</ng-select>
		<ng-select
			*ngIf="multiple && template === 'inline'"
			[id]="id"
			class="form-control inline-control"
			[ngClass]="{invalid: control.touched && control.errors}"
			[formControl]="control"
			[placeholder]="'― ' + placeholder"
			[multiple]="true"
			[compareWith]="compareWithIndex"
			[items]="innerOptions"
			bindLabel="item"
			bindValue="id"
			[closeOnSelect]="false"
			[isOpen]="true"
			(change)="checkSelectValue()"
			(open)="selectOpen = true"
			(close)="selectOpen = false">
			<ng-template ng-label-tmp let-item="item" let-clear="clear">
				<button class="btn btn-sm btn-outline-primary" type="button"
						[ngbTooltip]="item.key"
						container="body">
					<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true"><i class="fa-solid fa-xmark"></i></span>
					<span class="ng-value-label">{{item.key}}</span>
				</button>
			</ng-template>
			<ng-template ng-option-tmp let-item="item" let-index="index" let-item$="item$">
				<div class="option" title="{{item.key}}">
					<span class="option-content">{{item.key}}</span>
					<input class="checkbox" id="item-inline-{{index}}" type="checkbox" [ngModel]="item$.selected"/>
					<span class="checkmark"></span>
				</div>
			</ng-template>
			<ng-template *ngIf="control.touched && control.errors" ng-footer-tmp>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-template>
		</ng-select>


		<div class="indicators-wrapper">
			<div *ngIf="(control.touched || control.dirty) && control.errors" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-xmark"></i>
				</span>
			</div>

			<div *ngIf="control.valid && (!control.pristine || control.value)" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fa-solid fa-check"></i>
				</span>
			</div>

			<div *ngIf="warnings && warnings.deprecated" class="icon-indicator separator">
				<span class="inner-wrapper">
					<i class="fal fa-exclamation-triangle"></i>
				</span>
			</div>

			<div *ngIf="control.disabled" class="icon-indicator separator">
				<span class="inner-wrapper">
					<shared-icon-sprite svgId="lock" height="22px" width="18px" class="mb-2"></shared-icon-sprite>
				</span>
			</div>

			<div *ngIf="!selectOpen && template !== 'inline'" class="icon-indicator action-btn separator">
				<span class="inner-wrapper">
					<button class="btn shadow-none bg-transparent"
							(click)="openSelect()"
							type="button">
						<i class="fas fa-chevron-down"></i>
					</button>
				</span>
			</div>

			<div *ngIf="selectOpen || template === 'inline'" class="icon-indicator separator color-primary separator">
				<span class="inner-wrapper search-icon">
					<shared-icon-sprite svgId="search" height="20px" width="20px" class="mb-1"></shared-icon-sprite>
				</span>
			</div>
		</div>

	</div>
</ng-template>

<ng-template #vertical>
	<div class="input-group input-vertical select-wrapper">
		<div class="input-container col-12"
			 [class.input-disabled]="control.disabled"
			 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			 [class.input-container-valid]="control.valid && control.value">
			<label *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #horizontal>
	<div class="input-group input-horizontal select-wrapper">
		<div  class="input-container col-12"
			  [class.input-disabled]="control.disabled"
			  [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
			  [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
			  [class.input-container-valid]="control.valid && control.value">
			<label *transloco="let t; read: 'journal'"
				   [for]="id">{{label}}
				<ng-container *ngFor="let warning of warnings | keyvalue">
					<span *ngIf="warning.value"
						  [ngbTooltip]="t('warnings.'+warning.key)"
						  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
			</label>
			<ng-container *ngTemplateOutlet="input"></ng-container>
		</div>
	</div>
</ng-template>

<ng-template #errors>
	<ng-container *ngIf="control.touched">
		<div class="control-errors-wrapper">
			<div [ngClass]="{'control-errors-vertical': template === ControlTemplate.vertical}"
				 class="control-errors col-12" *ngFor="let error of control.errors | keyvalue">
				<span class="error">{{error.value}}</span>
			</div>
		</div>
	</ng-container>
</ng-template>

<ng-container>
	<ng-container *ngIf="template !== 'inline'">
		<div [ngSwitch]="template" class="form-control-container">
			<ng-container *ngSwitchCase="ControlTemplate.horizontal">
				<ng-container *ngTemplateOutlet="horizontal"></ng-container>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
			<ng-container *ngSwitchCase="ControlTemplate.vertical">
				<ng-container *ngTemplateOutlet="vertical"></ng-container>
				<ng-container *ngTemplateOutlet="errors"></ng-container>
			</ng-container>
		</div>
	</ng-container>

	<ng-container *ngIf="template === 'inline'">
		<div class="select-inline-container">
			<div class="inline-label-wrapper"
				 [ngbPopover]="inlineNgSelect"
				 container="body"
				 placement="bottom auto">
				<label *transloco="let t; read: 'journal'"
					   [for]="id">{{label}}
					<ng-container *ngFor="let warning of warnings | keyvalue">
								<span *ngIf="warning.value"
									  [ngbTooltip]="t('warnings.'+warning.key)"
									  container="body">({{t('generic.'+warning.key)}})</span></ng-container>
				</label>
			</div>

			<ng-template #inlineNgSelect>
				<div class="select-inline select-wrapper">
					<div class="input-container"
						 [class.input-disabled]="control.disabled"
						 [class.input-container-pristine]="control.pristine && !control.disabled  || (control.valid && !control.value)"
						 [class.input-container-invalid]="(control.touched || control.dirty) && control.errors"
						 [class.input-container-valid]="control.valid && control.value">

						<ng-container *ngTemplateOutlet="input"></ng-container>
					</div>
				</div>
			</ng-template>
		</div>
	</ng-container>
</ng-container>

